module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "next"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _c('a', {
    attrs: {
      "href": "#/NothingsWrong5#_idTextAnchor000"
    }
  }, [_vm._v("Author’s Foreword"), _c('span', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_DropCap"
  }, [_c('span', {
    staticClass: "initial-cap _idGenCharOverride-3"
  }, [_vm._v("T")]), _vm._v("his book is the culmination of a long-term project that means a great deal to me. It began with a single page of notes for a client. Indeed, it has been from my practice of family counseling that I have had opportunities to learn firsthand from clients—men and women—about the topic of men and"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" feelings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Thus, I want to thank the wonderful clients of my practice for trusting me with the stories of their lives. They are a deep bless"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ing to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ChapterPages_Space-Divider-Ornament"
  }, [_c('span', {
    staticClass: "_0--Black"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "src": "image/11.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("We live in a culture that is besieged by violence in many forms, most of it committed by men. My conviction, stated in the simplest and most basic terms, is that much of the violence—from wars and mass shootings to thefts and misdemeanors—is the result of repressed, unexpressed emotions in the lives of the perpetrators. Emotions, one way or another, will come out; if not intentionally and healthily expressed by their owner, then they will come out on their own, most often with negative results. It’s the nature of feelings to find some way of getting "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("expressed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("In the same way, but with an emphasis on the positive, imagine all the wonders the world is missing because of the unexpressed feelings of men: discoveries, artistic creations, expressions of kindness, generosities, adventures of the mind and body, service and caring, and "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("on and on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Thus, my goal here is to the provide a simple and effective guide for the healthy expression of emotions for men. The focus is clear and specific: how men can become skilled and confident with the feeling part of life. Think of it as the course no one ever offered you: Feelings 101. I have tried to keep the journey short and sweet, the work light, and the pa"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("yoff huge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body _idGenParaOverride-1"
  }, [_vm._v("Welcome.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-775c14c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NothingsWrong-6.vue
// module id = 78
// module chunks = 0